import React from "react";
import Public from "./Public";
import Private from "./Private";

import "./assets/styles/general.scss";

function App() {
  const data = "salom";
  console.log(data);
  // if (data == "salom") {
    return <Public />;
  // } else {
    // return <Private />;
  // }
}

export default App;
